import React, { useState } from 'react';
import './App.css';

const API_URL = 'https://ffecdeke4a.execute-api.ap-northeast-2.amazonaws.com/prod/submit-answer';

function App() {
  const [currentUser, setCurrentUser] = useState('');
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answeredQuestions, setAnsweredQuestions] = useState(new Set());
  const [showQuiz, setShowQuiz] = useState(false);
  const [showQuizForm, setShowQuizForm] = useState(false);
  const [answer, setAnswer] = useState('');

  const startQuiz = () => {
    const name = document.getElementById('userName').value;
    const count = parseInt(document.getElementById('questionCount').value);
    
    if (!name || !count) {
      alert('이름과 문제 수를 입력하세요');
      return;
    }

    setCurrentUser(name);
    setTotalQuestions(count);
    setShowQuiz(true);
  };

  const openQuestion = (questionNum) => {
    setCurrentQuestion(questionNum);
    setAnswer('');
    setShowQuizForm(true);
  };

  const submitAnswer = async () => {
    if (!answer) {
      alert('답을 입력하세요');
      return;
    }

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: currentUser,
          questionNumber: currentQuestion,
          answer: answer
        })
      });

      if (response.ok) {
        const newAnsweredQuestions = new Set(answeredQuestions);
        newAnsweredQuestions.add(currentQuestion);
        setAnsweredQuestions(newAnsweredQuestions);
        setShowQuizForm(false);
        alert('답이 제출되었습니다!');
      } else if (response.status === 409) {
        alert('이미 제출된 문제입니다.');
      } else {
        alert('제출 중 오류가 발생했습니다');
      }
    } catch (error) {
      alert('네트워크 오류가 발생했습니다');
    }
  };

  const createQuestionGrid = () => {
    const boxes = [];
    for (let i = 1; i <= totalQuestions; i++) {
      boxes.push(
        <div
          key={i}
          className={`question-box ${answeredQuestions.has(i) ? 'answered' : ''}`}
          onClick={() => openQuestion(i)}
        >
          {i}
        </div>
      );
    }
    return boxes;
  };

  return (
    <div className="container">
      <h1>🔔 Golden Bell Quiz</h1>
      
      {!showQuiz && (
        <div id="nameForm">
          <h2>이름을 입력하세요</h2>
          <input type="text" id="userName" placeholder="이름" required />
          <br />
          <input type="number" id="questionCount" placeholder="문제 수" min="1" max="50" required />
          <br />
          <button onClick={startQuiz}>시작하기</button>
        </div>
      )}

      {showQuiz && (
        <div id="quizArea">
          <h2>{currentUser}님, 문제를 선택하세요!</h2>
          <div className="question-grid">
            {createQuestionGrid()}
          </div>
          
          {showQuizForm && (
            <div className="quiz-form">
              <h3>문제 {currentQuestion}</h3>
              <input
                type="text"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                placeholder="답을 입력하세요"
                required
              />
              <br />
              <button onClick={submitAnswer}>제출</button>
              <button onClick={() => setShowQuizForm(false)}>닫기</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default App;
